// extracted by mini-css-extract-plugin
export var completionBody = "_c0-2";
export var completionCard = "_c0-0";
export var completionFooter = "_c0-3";
export var completionTitle = "_c0-1";